export const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right'
};

export const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
